export const TABLE_CONTAINER_HEIGHT = 240;
export const TABLE_ROW_HEIGHT = 48;
export const SKELETON_HEIGHT = 40;
